import { GeoserverWMSProvider } from '../GeoserverWMSProvider'
import { WmsBaseLayer } from './WmsBaseLayer'

export class WmsDwrtLayer extends WmsBaseLayer {
  layername: string = '航道'
  key: string = 'dwrt'
  provider = new GeoserverWMSProvider({
    url: 'iserver/services/map-ugcv5-dwcladpt/wms111/dwcladpt',
    layers: 'dwcladpt',
  })
}
